import * as React from "react";

export const OpsanioIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="99.59"
    height="115"
    version="1.1"
    viewBox="-0.9 0 26.35 30.427"
    {...props}
  >
    <g>
      <path
        fill="#26388b"
        fillOpacity="1"
        stroke="#26388b"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.003"
        d="m14.62 29.072-2.344 1.355L-.9 22.82V7.607h2.344v13.859Z"
      ></path>
      <g
        fillOpacity="1"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.003"
        display="inline"
      >
        <path
          fill="#009eae"
          stroke="#009eae"
          d="m9.793 6.85 2.483-1.434 8.483 4.9v2.866z"
        ></path>
        <path
          fill="#26388b"
          stroke="#26388b"
          d="m4.964 9.639 2.484-1.435 13.31 7.687v2.868z"
        ></path>
        <path
          fill="#3e73b9"
          stroke="#3e73b9"
          d="M3.791 14.536v-2.868l15.796 9.12-2.483 1.434z"
        ></path>
        <path
          fill="#78c9d9"
          stroke="#78c9d9"
          d="M3.791 17.246v2.865l8.484 4.899 2.484-1.434z"
        ></path>
      </g>
      <path
        fill="#3e73b9"
        fillOpacity="1"
        stroke="#3e73b9"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.003"
        d="m9.93 29.072 2.346 1.355L25.45 22.82V7.607h-2.344v13.859L9.929 29.072"
      ></path>
      <path
        fill="#3e73b9"
        fillOpacity="1"
        stroke="#3e73b9"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.003"
        d="M9.93 1.355 12.275 0 25.45 7.607V22.82h-2.344V8.961L9.929 1.355"
      ></path>
      <path
        fill="#26388b"
        fillOpacity="1"
        stroke="#26388b"
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="0.003"
        d="M14.62 1.355 12.276 0-.9 7.607V22.82h2.344V8.961Z"
      ></path>
    </g>
  </svg>
);
